import React from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import classes from './Page.module.css';
import TawkTo from "../TawkTo";

const Page = (props) => {
  return (
    <div className={classes.page}>
        <Header />
        <TawkTo />
            {props.children}
        <Footer />
    </div>
  )
}

export default Page